import { render, staticRenderFns } from "./unBind.vue?vue&type=template&id=5178706a&scoped=true"
import script from "./unBind.vue?vue&type=script&lang=js"
export * from "./unBind.vue?vue&type=script&lang=js"
import style0 from "./unBind.vue?vue&type=style&index=0&id=5178706a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5178706a",
  null
  
)

export default component.exports